import SnackbarModule from "@/store/modules/snackbar";
import { getModule } from "vuex-module-decorators";

export const notification = getModule(SnackbarModule);
